<template>
  <modal
    :visible="visible"
    class="preview"
    :title="clipPreviewTitle"
    can-close
    @close="$emit('close')"
  >
    <template v-slot:body>
      <preview-player
        v-if="isTimeInited"
        class="preview-player"
        :paused.sync="previewPaused"
        :begin-time="beginTime"
        :end-time="endTime"
        :poster="clipPreviewPoster"
        :visible="visible"
      />
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/dialog/Modal.vue";
import PreviewPlayer from "@/components/media/video/PreviewPlayer.vue";

/** vuex */
import { mapState, mapGetters } from "vuex";

/** shortcuts locking utils */
import { lockShortcuts, unlockShortcuts } from "@/utils/shortcuts.js";

import { getTimeLine } from "@/utils/time.js";

// @group Dialog
// Modal with preview of trimming video
export default {
  name: "PreviewPlayerModal",
  components: {
    Modal,
    PreviewPlayer
  },
  props: {
    // is modal opened
    visible: {
      type: Boolean,
      default: false
    },
    // preview start time UNIX timestamp
    beginTime: {
      type: Number,
      default: null
    },
    // preview end time UNIX timestamp
    endTime: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      previewPaused: true
    };
  },
  computed: {
    ...mapState({
      /** hasThumbnails: state => state.services.hasThumbnails,*/
      poster: state => state.services.channelPoster,
      timezone: state => state.timezone.timezone
    }),
    ...mapGetters({
      hasThumbnails: "hasThumbnails"
    }),
    isTimeInited() {
      return this.beginTime && this.endTime;
    },
    // @vuese
    // Preview video title description
    clipPreviewTitle() {
      return `Clip from ${this.cropBeginTimeString} to ${this.cropEndTimeString}`;
    },
    // @vuese
    // Preview poster
    clipPreviewPoster() {
      if (this.hasThumbnails) {
        const poster = this.getThumbnailLink()(this.beginTime);
        return poster;
      }
      return this.poster;
    },
    // @vuese
    // Start time string
    cropBeginTimeString() {
      return getTimeLine(this.beginTime, this.timezone);
    },
    // @vuese
    // End time string
    cropEndTimeString() {
      return getTimeLine(this.endTime, this.timezone);
    }
  },
  watch: {
    // @vuese
    // Subscribe/unsubscribe on P shortcut
    visible() {
      if (this.visible) {
        lockShortcuts();
        document.addEventListener("keydown", this.handleKey);
      } else {
        document.removeEventListener("keydown", this.handleKey);
        this.previewPaused = true;
        setTimeout(() => unlockShortcuts(), 1000);
      }
    }
  },
  methods: {
    ...mapGetters("thumbnails", ["getThumbnailLink"]),
    // @vuese
    // Close modal by K
    handleKey({ code }) {
      if (code == "KeyP") {
        this.$emit("close");
      }
    }
  }
};
</script>

<style>
.preview-player {
  width: 67vw;
}
</style>
